import React from 'react';

import { rentalTiers } from '../utils/rentalPrice';

const dayLabel = (days) => `${days} ${days === 1 ? 'giorno' : 'giorni'}`;

/**
 * Listino di un dispositivo di noleggio, condiviso da elenco e scheda.
 *
 * Mostra solo gli scaglioni valorizzati: quelli vuoti arrivano dall'API come
 * `null` e finivano in `parseFloat(null).toFixed(2)`, cioè "NaN€". Rimpiazzarli
 * con uno zero sarebbe stato peggio, perché suggerirebbe che quella durata sia
 * gratis mentre in realtà paga la tariffa dello scaglione sotto.
 *
 * `emptyLabel` cambia fra le due schermate: la scheda dice "Gratuito", l'elenco
 * "Prezzo non disponibile".
 */
export default function RentalPriceSummary({ device, emptyLabel }) {
  if (device.price_type === 'single') {
    return device.price > 0 ? <>{parseFloat(device.price).toFixed(2)}€</> : <>{emptyLabel}</>;
  }

  const tiers = rentalTiers(device);

  // "al giorno" vale solo se l'unico scaglione è quello da un giorno: con un
  // solo scaglione più lungo la cifra è il totale di quella durata, non la
  // tariffa giornaliera.
  if (tiers.length === 1 && tiers[0].days === 1) {
    return <>{tiers[0].price.toFixed(2)}€ al giorno</>;
  }

  if (tiers.length > 0) {
    return (
      <>
        {tiers.map((tier) => `${tier.price.toFixed(2)}€`).join(' / ')}
        <br />
        <small style={{ color: 'var(--ion-color-medium)' }}>
          {tiers.map((tier) => dayLabel(tier.days)).join(' · ')}
        </small>
      </>
    );
  }

  if (device.price > 0) return <>{parseFloat(device.price).toFixed(2)}€ al giorno</>;

  return <>{emptyLabel}</>;
}
